export default "__VITE_ASSET__SlPhXBo2__"